export enum UserClass {
  BENUTZER = 'BENUTZER',
  MITARBEITER = 'MITARBEITER',
  RESSOURCE = 'RESSOURCE',
}
